import React, { useCallback, useState } from 'react';
import Container from '@material-ui/core/Container';
import { AppBar, Drawer, Grid, makeStyles, Tab, Tabs, Theme } from '@material-ui/core';
import { IoIosCloseCircleOutline } from 'react-icons/io';

import Detalhes from './tabs/Detalhes';
import Complementos from './tabs/Complementos';

import { useGrupoPizza } from '../../../../../../../hooks/grupoPizza';

import { DrawerTitle, NewComplementoGrupo } from '../../../drawer_styles';
import { CloseButton, DrawerContainer } from '../../../../../../../components/Drawer/styles';
import TabPanel from '../../../../../../Configuracoes/TabBar/TabPanel';

interface ComplementoProps {
  isEnabled: boolean;
}

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  noShadow: {
    boxShadow: 'none',
  },
  tabBorder: {
    borderBottom: '1px solid #e0e0e0',
  },
  noPaddingTop: {
    paddingTop: '0 !important',
  },
}));

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const Complemento: React.FC<ComplementoProps> = ({ isEnabled }) => {
  const classes = useStyles();

  const {
    grupoPizzaData,
    complementosDrawerIsOpen,
    itensComplementosIsEnabled,
    currentComplementosTabIndex,
    toggleComplementosDrawer,
    changeSelectedComplementoIndex,
    changeCurrentComplementosTabIndex,
  } = useGrupoPizza();

  const handleToggleComplementosDrawer = useCallback(() => {
    toggleComplementosDrawer();
    changeSelectedComplementoIndex(grupoPizzaData.complementos.length);
  }, [grupoPizzaData, toggleComplementosDrawer, changeSelectedComplementoIndex]);

  return (
    <>
      <NewComplementoGrupo onClick={handleToggleComplementosDrawer} disabled={!isEnabled}>
        + Criar Grupo de Complementos
      </NewComplementoGrupo>

      <Drawer
        anchor="right"
        open={complementosDrawerIsOpen}
        onClose={toggleComplementosDrawer}
      >
        <CloseButton type="button" onClick={toggleComplementosDrawer}>
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation" className={classes.noPaddingTop}>
          <Container maxWidth="lg">
            <Grid item xs={12}>
              <DrawerTitle className="titleDrawer_with_tabs">
                <h1>Complementos</h1>
              </DrawerTitle>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.root}>
                <AppBar
                  position="static"
                  color="transparent"
                  className={classes.noShadow}
                >
                  <Tabs
                    value={currentComplementosTabIndex}
                    onChange={(_event, tabIndex) => changeCurrentComplementosTabIndex(tabIndex)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="product tabs"
                    className={classes.tabBorder}
                  >
                    <Tab label="Detalhes" {...a11yProps(0)} />
                    <Tab
                      label="Complementos"
                      disabled={!itensComplementosIsEnabled}
                      {...a11yProps(1)}
                    />
                  </Tabs>
                </AppBar>

                <TabPanel value={currentComplementosTabIndex} index={0}>
                  <Detalhes />
                </TabPanel>

                <TabPanel value={currentComplementosTabIndex} index={1}>
                  <Complementos />
                </TabPanel>
              </div>
            </Grid>
          </Container>
        </DrawerContainer>
      </Drawer>
    </>
  );
}

export default Complemento;
